module.exports = __webpack_public_path__ + "img/whitepaper.3ee84d2a.png";